import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/jydt-detail',
    name: 'jydtDetail',
    component: () => import('../views/JydtDetail.vue')
  },
  {
    path: '/mtzx-detail',
    name: 'mtzxDetail',
    component: () => import('../views/MtzxDetail.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/auction-detail',
    name: 'auctionDetail',
    component: () => import('../views/AuctionDetail.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
// router.beforeEach((to, from, next) => {
//   // console.log(to,from,next)
//   if (to.path == "/login") {
//     localStorage.setItem("fromPath", from.path)
//     return next();
//   }
//   let tokenStr = sessionStorage.getItem("token")
//   if (!tokenStr) {
//     return next('/login')
//   }
//   next()
// })
export default router
